/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentVariation } from './ContentVariation';
import {
    ContentVariationFromJSON,
    ContentVariationFromJSONTyped,
    ContentVariationToJSON,
} from './ContentVariation';
import type { Int32Lazy } from './Int32Lazy';
import {
    Int32LazyFromJSON,
    Int32LazyFromJSONTyped,
    Int32LazyToJSON,
} from './Int32Lazy';
import type { ValueStorageType } from './ValueStorageType';
import {
    ValueStorageTypeFromJSON,
    ValueStorageTypeFromJSONTyped,
    ValueStorageTypeToJSON,
} from './ValueStorageType';

/**
 * 
 * @export
 * @interface IPropertyType
 */
export interface IPropertyType {
    /**
     * 
     * @type {number}
     * @memberof IPropertyType
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPropertyType
     */
    key?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPropertyType
     */
    createDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPropertyType
     */
    updateDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPropertyType
     */
    deleteDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IPropertyType
     */
    readonly hasIdentity?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPropertyType
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertyType
     */
    alias?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertyType
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof IPropertyType
     */
    dataTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof IPropertyType
     */
    dataTypeKey?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertyType
     */
    propertyEditorAlias?: string;
    /**
     * 
     * @type {ValueStorageType}
     * @memberof IPropertyType
     */
    valueStorageType?: ValueStorageType;
    /**
     * 
     * @type {Int32Lazy}
     * @memberof IPropertyType
     */
    propertyGroupId?: Int32Lazy;
    /**
     * 
     * @type {boolean}
     * @memberof IPropertyType
     */
    mandatory?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPropertyType
     */
    labelOnTop?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IPropertyType
     */
    sortOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof IPropertyType
     */
    validationRegExp?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPropertyType
     */
    supportsPublishing?: boolean;
    /**
     * 
     * @type {ContentVariation}
     * @memberof IPropertyType
     */
    variations?: ContentVariation;
    /**
     * 
     * @type {string}
     * @memberof IPropertyType
     */
    mandatoryMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof IPropertyType
     */
    validationRegExpMessage?: string;
}

/**
 * Check if a given object implements the IPropertyType interface.
 */
export function instanceOfIPropertyType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IPropertyTypeFromJSON(json: any): IPropertyType {
    return IPropertyTypeFromJSONTyped(json, false);
}

export function IPropertyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPropertyType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'key': !exists(json, 'Key') ? undefined : json['Key'],
        'createDate': !exists(json, 'CreateDate') ? undefined : (new Date(json['CreateDate'])),
        'updateDate': !exists(json, 'UpdateDate') ? undefined : (new Date(json['UpdateDate'])),
        'deleteDate': !exists(json, 'DeleteDate') ? undefined : (new Date(json['DeleteDate'])),
        'hasIdentity': !exists(json, 'HasIdentity') ? undefined : json['HasIdentity'],
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'alias': !exists(json, 'Alias') ? undefined : json['Alias'],
        'description': !exists(json, 'Description') ? undefined : json['Description'],
        'dataTypeId': !exists(json, 'DataTypeId') ? undefined : json['DataTypeId'],
        'dataTypeKey': !exists(json, 'DataTypeKey') ? undefined : json['DataTypeKey'],
        'propertyEditorAlias': !exists(json, 'PropertyEditorAlias') ? undefined : json['PropertyEditorAlias'],
        'valueStorageType': !exists(json, 'ValueStorageType') ? undefined : ValueStorageTypeFromJSON(json['ValueStorageType']),
        'propertyGroupId': !exists(json, 'PropertyGroupId') ? undefined : Int32LazyFromJSON(json['PropertyGroupId']),
        'mandatory': !exists(json, 'Mandatory') ? undefined : json['Mandatory'],
        'labelOnTop': !exists(json, 'LabelOnTop') ? undefined : json['LabelOnTop'],
        'sortOrder': !exists(json, 'SortOrder') ? undefined : json['SortOrder'],
        'validationRegExp': !exists(json, 'ValidationRegExp') ? undefined : json['ValidationRegExp'],
        'supportsPublishing': !exists(json, 'SupportsPublishing') ? undefined : json['SupportsPublishing'],
        'variations': !exists(json, 'Variations') ? undefined : ContentVariationFromJSON(json['Variations']),
        'mandatoryMessage': !exists(json, 'MandatoryMessage') ? undefined : json['MandatoryMessage'],
        'validationRegExpMessage': !exists(json, 'ValidationRegExpMessage') ? undefined : json['ValidationRegExpMessage'],
    };
}

export function IPropertyTypeToJSON(value?: IPropertyType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Key': value.key,
        'CreateDate': value.createDate === undefined ? undefined : (value.createDate.toISOString()),
        'UpdateDate': value.updateDate === undefined ? undefined : (value.updateDate.toISOString()),
        'DeleteDate': value.deleteDate === undefined ? undefined : (value.deleteDate.toISOString()),
        'Name': value.name,
        'Alias': value.alias,
        'Description': value.description,
        'DataTypeId': value.dataTypeId,
        'DataTypeKey': value.dataTypeKey,
        'PropertyEditorAlias': value.propertyEditorAlias,
        'ValueStorageType': ValueStorageTypeToJSON(value.valueStorageType),
        'PropertyGroupId': Int32LazyToJSON(value.propertyGroupId),
        'Mandatory': value.mandatory,
        'LabelOnTop': value.labelOnTop,
        'SortOrder': value.sortOrder,
        'ValidationRegExp': value.validationRegExp,
        'SupportsPublishing': value.supportsPublishing,
        'Variations': ContentVariationToJSON(value.variations),
        'MandatoryMessage': value.mandatoryMessage,
        'ValidationRegExpMessage': value.validationRegExpMessage,
    };
}

